import { Link } from '@tanstack/react-router';

import { NavLabel } from '../../components/shell/NavLabel';
import type { PlanTier } from '../../lib/plan';
import { AdvisorOrb } from './AdvisorOrb';

const NAV_ORB = 26;

/** Dale Agents' reports, under the agents with Júpiter's dot. */
export function IntelligenceNavLink({ onNavigate, lock }: { onNavigate?: () => void; lock?: PlanTier }) {
  return (
    <Link
      to="/inteligencia"
      className="nav-item nav-agents nav-intel"
      activeOptions={{ exact: false }}
      activeProps={{ 'data-status': 'active' }}
      onClick={onNavigate}
    >
      <AdvisorOrb personaId="direccion" size={NAV_ORB} />
      <span className="nav-agents-label">
        <NavLabel label="Informes" lock={lock} />
      </span>
    </Link>
  );
}
